var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#1E95F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12L10.3234 15.3234C10.4406 15.4406 10.6305 15.4406 10.7477 15.3234L17.6066 8.46447",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedCheckboxChecked);
export default __webpack_public_path__ + "static/media/rounded-checkbox-checked.02b26a57fbeeb09fcda4d4c8aa0f581f.svg";
export { ForwardRef as ReactComponent };